import { render } from "./AppMenu.vue?vue&type=template&id=12f90ff3&scoped=true&ts=true"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"

import "./AppMenu.vue?vue&type=style&index=0&id=12f90ff3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f90ff3"]])

export default __exports__